var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReadOnly = function SvgReadOnly(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#67647F",
    d: "M9.35 8a1.35 1.35 0 1 1-2.7 0 1.35 1.35 0 0 1 2.7 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#67647F",
    fillRule: "evenodd",
    d: "M15.819 8.693c.238-.436.238-.95 0-1.386-.895-1.639-3.516-5.612-7.882-5.612-4.394 0-6.928 4.023-7.77 5.642-.218.42-.218.906 0 1.326.842 1.619 3.376 5.642 7.77 5.642 4.366 0 6.987-3.973 7.882-5.612m-7.82 2.457a3.15 3.15 0 1 0 0-6.3 3.15 3.15 0 0 0 0 6.3",
    clipRule: "evenodd"
  })));
};
export { SvgReadOnly as ReactComponent };